import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { ConfigurationValue } from './configuration/configuration-value';


@inheritSerialization(AbstractModel)
export class DriverRideConfiguration extends AbstractModel {
  @autoserializeAs(ConfigurationValue)
  riderIdCaptureFlag: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  riderIdCardImage: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  riderIdProgramName: ConfigurationValue;
}
